import { api } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { useGetContestQuery } from '../contests/getContest';

const updateRound = (round: any) =>
  api.put(`/contest-weeks/${round.contest_week_id}`, round);

export const useUpdateRoundMutation = (contestId: number) => {
  const { refetch } = useGetContestQuery(contestId);

  return useMutation({
    mutationKey: ['update-round', contestId],
    mutationFn: updateRound,
    onSuccess: () => {
      toast.success('Round updated successfully');
      refetch();
    },
    onError: (error) => {
      Promise.reject(error); // catch error in ErrorBoundary
    },
  });
};
